var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8686,
    cy: 27.3691,
    r: 26.936,
    fill: "#F9F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6581 37.6061C24.3963 37.8694 24.0392 38.0164 23.6681 38.0164C23.2971 38.0164 22.94 37.8694 22.6781 37.6061L14.7722 29.6988C13.9516 28.8782 13.9516 27.5479 14.7722 26.7288L15.7622 25.7388C16.5827 24.9182 17.9116 24.9182 18.7321 25.7388L23.6681 30.6748L37.0058 17.3371C37.8263 16.5165 39.1566 16.5165 39.9758 17.3371L40.9658 18.3271C41.7863 19.1477 41.7863 20.4779 40.9658 21.2971L24.6581 37.6061Z",
    fill: "#B6ABFE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.810e8e3485ba57714987091e0a186e3a.svg";
export { ForwardRef as ReactComponent };